export const useSizeChartsStore = defineStore('sizeCharts', {
  state: () => ({
    guides: [],
    categories: [],
    categoryLinks: [],
  }),
})